import React from "react";
import {
  TRACKS,
  FOUNDATIONS,
  SCALES,
  scaleTeach,
  unitTeach,
} from "../../lib/numberSenseData";
import { Icon, Keys } from "../numberSenseUi";

/* ============================================================
   Number Sense — the Learn library: a browsable index of every
   concept. Foundations first (the cross-cutting ideas), then each
   track's units. Tapping a card opens its slides in the shared
   TeachScreen (read-only).

   Props:
     onOpen : ({ title, slides }) => void
     onBack : () => void
   ============================================================ */
const Row = ({ title, sub, onClick }) => (
  <button className="learn-row" onClick={onClick}>
    <div className="ic">
      <Icon name="book" />
    </div>
    <div className="txt">
      <div className="ttl">{title}</div>
      {sub && <div className="sub">{sub}</div>}
    </div>
    <span className="chev">›</span>
  </button>
);

const LearnScreen = ({ onOpen, onBack }) => (
  <div className="ns-root">
    <div className="ns-app">
      <div className="subbar">
        <button className="iconbtn" onClick={onBack} aria-label="back">
          <Icon name="back" />
        </button>
        <div className="subbar-title">learn</div>
      </div>
      <div className="scroll">
        <p className="games-intro">
          The ideas behind the drills — read any time. Start with the
          foundations, then the concept behind each unit.
        </p>

        <div className="learn-section">foundations</div>
        {FOUNDATIONS.map((f) => (
          <Row
            key={f.id}
            title={f.title}
            sub={f.teach[0].title}
            onClick={() => onOpen({ title: f.title, slides: f.teach })}
          />
        ))}

        <div className="learn-section">scales</div>
        {SCALES.map((s) => (
          <Row
            key={s.id}
            title={`${s.title} scale`}
            sub="the seven notes & their chords"
            onClick={() => onOpen({ title: `${s.title} scale`, slides: scaleTeach(s.key) })}
          />
        ))}

        {TRACKS.map((track) => {
          const taught = track.units.filter((u) => unitTeach(u.id));
          if (!taught.length) return null;
          return (
            <React.Fragment key={track.id}>
              <div className="learn-section">{track.title}</div>
              {taught.map((u) => (
                <Row
                  key={u.id}
                  title={u.title}
                  sub={u.gloss}
                  onClick={() => onOpen({ title: u.title, slides: unitTeach(u.id) })}
                />
              ))}
            </React.Fragment>
          );
        })}

        <div className="footnote">
          <Keys />
        </div>
      </div>
    </div>
  </div>
);

export default LearnScreen;
